import coreApi from '../coreApi';
import { AxiosError } from 'axios';
import { GetActualFilePathParams, GetDownloadListParams } from 'types/worker/downloads';

export const getDownloads = (params: GetDownloadListParams) => {
  return coreApi
    .get<GetDownloadListParams>(`/Workers/Download/Items`, {
      params: { ...params },
    })
    .catch((error: AxiosError<Error>) => ({ error }));
};

export const getActualFilePath = (params: GetActualFilePathParams) => {
  return coreApi
    .get<GetActualFilePathParams>(`Workers/Download/Items/ActualFile`, {
      params: { ...params },
    })
    .catch((error: AxiosError<Error>) => ({ error }));
};

export const getSRest = (params: GetActualFilePathParams) => {
  return coreApi
    .get<GetActualFilePathParams>(`Workers/Download/Items/Srest`, {
      params: { ...params },
    })
    .catch((error: AxiosError<Error>) => ({ error }));
};
